import type { FC } from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import type { TimeEntry } from "../types";

const TONE: Record<string, string> = {
  released: "border-warn-line bg-warn-soft text-warn",
  approved: "border-success-line bg-success-soft text-success",
  exported: "border-line-2 bg-fill-2 text-fg-3",
  returned: "border-danger-line bg-danger-soft text-danger"
};

export const ReviewStatus: FC<{
  entry: Pick<TimeEntry, "status" | "status_label">;
}> = ({ entry }) => (
  <Badge
    variant="secondary"
    className={cn("h-5 text-sm font-medium", TONE[entry.status])}
  >
    {entry.status_label}
  </Badge>
);
